import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

const SlidePickerMenuItem = ({
  Component,
  index,
  label,
  isActive,
  onClick
}) => {
  const onClickLocal = useCallback(() => {
    onClick(index);
  }, [onClick, index]);

  return (
    <Component
      onClick={onClickLocal}
      selected={isActive}
      data-viz-at={'slide-picker-slide-name'}
    >
      {index + 1}. {label}
    </Component>
  );
};

SlidePickerMenuItem.propTypes = {
  Component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]).isRequired,
  index: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default SlidePickerMenuItem;
